export const RECENT_SEARCH_WIDTH_IN_PX = 420;
export const RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX = 360;
export const RECENT_SEARCH_HEIGHT_IN_PX = 360;
export const LINKPICKER_HEIGHT_IN_PX = 570;

// Dimensions of RovoLinkPicker — used by the editor popup to prevent off-screen rendering.
// Note: These values are mirrored from @atlassian/rovo-link-picker. If you change these, update that package's constants file too:
// platform/packages/linking-platform/rovo-link-picker/src/constants/ROVO_LINK_PICKER_CONSTANTS.ts
export const ROVO_LINK_PICKER_WIDTH_IN_PX = 464;
export const ROVO_LINK_PICKER_HEIGHT_IN_PX = 512;
